export default "__VITE_ASSET__BPdqg9lF__"